import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { MainLayout } from './../layouts/MainLayout';
import { FeedPage } from './../pages/Portal/FeedPage';
import { ProfilePage } from './../pages/Portal/ProfilePage';
import { NotificationsPage } from './../pages/Portal/ProfilePage/Notifications';
import { ProtectedRoute } from './ProtectedRoute';
import { UnprotectedRoute } from './UnprotectedRoute';
import { GuestLayout } from '../layouts/GuestLayout';
import { Login } from '../pages/Public/Login';
import { ActivateAccount } from '@pages/Public/ActivateAccount';
import {
  manageAssociationRoutes,
  manageCompetitions,
  manageMembersRoles,
  manageMembersRoutes,
  manageNewsRoutes,
  portalAssociationRoutes,
  portalCompetitionsRoutes,
  portalNewsRoutes,
  portalPhotosRoutes,
} from './pages';
import { portalEventsRoutes } from './pages/portal/portalEventsRoutes';
import { portalDutyScheduleRoutes } from './pages/portal/portalDutyScheduleRoutes';
import { Box } from '@mui/material';
import { ForgotPassword } from '@pages/Public/ForgotPassword';
import { ResetPassword } from '@pages/Public/ResetPassword';

export const AppRouter: React.FC = () => {
  return (
    <Suspense fallback={<Box></Box>}>
      <Routes>
        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            <Route index element={<FeedPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="profile/notifications" element={<NotificationsPage />} />

            {portalNewsRoutes}
            {portalEventsRoutes}
            {portalPhotosRoutes}
            {portalCompetitionsRoutes}
            {portalAssociationRoutes}
            {portalDutyScheduleRoutes}

            <Route path="manage">
              {manageMembersRoutes}
              {manageMembersRoles}
              {manageCompetitions}
              {manageNewsRoutes}
              {manageAssociationRoutes}
            </Route>
          </Route>
        </Route>

        <Route element={<UnprotectedRoute />}>
          <Route index element={<Navigate to="login" replace />} />

          <Route element={<GuestLayout />}>
            <Route path="/login" element={<Login />} />
            <Route path="/activate" element={<ActivateAccount />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
};
